module.exports = __webpack_public_path__ + "img/six-o'clock.a7154e98.png";